import * as React from "react"
import { Row, Col, Button, Alert } from "reactstrap"
import { FormattedMessage, intlShape } from "react-intl"
import { ValidationForm, TextInput } from "react-bootstrap4-form-validation"
import { connect } from "react-redux"
import SagaAuthRedux from "../../redux/sagaAuth/sagaAuthRedux"
import validator from "validator"

class ResetUserPassword extends React.Component<
  {
    resetUserPasswordFetching: boolean
    resetUserPasswordResponse: true
    resetUserPasswordError: string
    onSignIn: () => void
    requestResetUserPassword: (email: string) => void
  },
  {
    email: string
  }
> {
  /* tslint:disable */
  private static contextTypes = {
    intl: intlShape
  }

  constructor(props, context) {
    super(props)
    this.state = {
      email: ""
    }
    this.context = context
  }

  public componentWillReceiveProps(newProps) {
    const newState: any = {}
    newState.activeTab = newProps.activeTab
    this.setState(newState)
  }

  public onSubmit(e) {
    e.preventDefault()
    // invoke singin api
    this.props.requestResetUserPassword(this.state.email)
  }

  public render() {
    return (
      <ValidationForm className="mt-3" onSubmit={e => this.onSubmit(e)}>
        <div className="mb-3 form-group">
          <p className="text-center">
            <FormattedMessage id="resetpassword.header.second" />
          </p>
          <TextInput
            name="signin-email"
            id="signin-email"
            type="email"
            validator={validator.isEmail}
            placeholder={this.context.intl.formatMessage({ id: "Email" })}
            onChange={e => this.setState({ email: e.target.value })}
            errorMessage={{
              required: (
                <FormattedMessage id="Signin.Validation.Email.Required" />
              ),
              validator: (
                <FormattedMessage id="Signin.Validation.Email.Invalid" />
              )
            }}
            required
          />
        </div>

        <Row className="mb-3">
          <Col>
            <Button
              color="success"
              size="md"
              block
              disabled={this.props.resetUserPasswordFetching}
            >
              <FormattedMessage id="resetpassword.button.send" />
            </Button>
          </Col>
          <Col xs={{ size: "auto" }} className="text-right">
            <span className="anchor-span" onClick={() => this.props.onSignIn()}>
              <FormattedMessage id="Signin" />
            </span>
          </Col>
        </Row>

        {this.props.resetUserPasswordResponse ? (
          <Row className="mb-3">
            <Col>
              <Alert color="success">
                {<FormattedMessage id="resetpassword.Success" />}
              </Alert>
            </Col>
          </Row>
        ) : null}
        {this.props.resetUserPasswordError ? (
          <Row className="mb-3">
            <Col>
              <Alert color="danger">{this.props.resetUserPasswordError}</Alert>
            </Col>
          </Row>
        ) : null}
      </ValidationForm>
    )
  }
}

const mapStateToProps = state => {
  return {
    resetUserPasswordFetching: state.SagaAuth.resetUserPasswordFetching,
    resetUserPasswordResponse: state.SagaAuth.resetUserPasswordResponse,
    resetUserPasswordError: state.SagaAuth.resetUserPasswordError
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestResetUserPassword: (email: string) =>
      dispatch(SagaAuthRedux.requestResetUserPassword(email))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetUserPassword)



// WEBPACK FOOTER //
// ./src/components/accountModal/resetPassword.tsx